import { render, staticRenderFns } from "./CamposRegistroPersonalTabContent.vue?vue&type=template&id=027bc23e&scoped=true"
import script from "./CamposRegistroPersonalTabContent.vue?vue&type=script&lang=js"
export * from "./CamposRegistroPersonalTabContent.vue?vue&type=script&lang=js"
import style0 from "./CamposRegistroPersonalTabContent.vue?vue&type=style&index=0&id=027bc23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027bc23e",
  null
  
)

export default component.exports